import { collectPairsByIdFromContainer } from "../../lib/collectPairsById";
import type { KeyValuePair as SharedKeyValuePair } from "../../lib/normalizeSectionInputs";

export type KeyValuePair = SharedKeyValuePair;

export function collectCurrentKeyValuePairs(containerSelector: string): KeyValuePair[] {
  const container = document.querySelector(containerSelector);
  return collectPairsByIdFromContainer(container as Element | null);
}
